module.exports = __webpack_public_path__ + "static/media/Pokemon.0526c7db.png";